export default "__VITE_ASSET__gzwNFQFt__"